<template>
  <component
    v-if="item.id"
    :is="component"
    :item="item"
    :displayType="displayType"
    :variant="variant"
    :spinners="spinners"
    v-on="$listeners" />

</template>

<script>
const FacebookPost = () => import('./FacebookPost')
const SqwizArticle = () => import('./SqwizArticle')
const SqwizProduct = () => import('./SqwizProduct')
const TwitterTweet = () => import('./TwitterTweet')
const InformacijaProduct = () => import('./InformacijaProduct')
const InformacijaPost = () => import('./InformacijaPost')
const WoocommerceProduct = () => import('./WoocommerceProduct')
const WordpressPost = () => import('./WordpressPost')
const ProductPromotion = () => import('./ProductPromotion')
const DailyDeal = () => import('./DailyDeal')
const Sale = () => import('./Sale')
const Post = () => import('./Post')
const Product = () => import('./Product')

export default {
  computed: {
    component () {
      const { type } = this.item
      return `${type[0].toUpperCase()}${type.slice(1)}`
    },

    spinners () {
      return {
        remove: this.dataLoading
      }
    }
  },

  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    displayType: {
      type: String,
      default: 'grid'
    },
    variant: {
      type: String,
      default: 'basic'
    },
    dataLoading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    FacebookPost,
    SqwizArticle,
    SqwizProduct,
    TwitterTweet,
    InformacijaProduct,
    InformacijaPost,
    WoocommerceProduct,
    WordpressPost,
    ProductPromotion,
    DailyDeal,
    Sale,
    Post,
    Product
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/mpeGrid/GridItem.vue?21d1eb3c